  <button class="close" mat-button (click)="close()">X</button>
  <mat-spinner style="margin: auto;" *ngIf="showSpinner" ></mat-spinner>
  
  <div  [hidden]="showSpinner" style="max-height: 91vh;">
    <div>
      <div *ngIf="valueInstance <100  && showProgressBar; else showMessage">
        <mat-progress-bar
          class="example-margin"
          [color]="color"
          [mode]="mode"
          [value]="value">
        </mat-progress-bar><br><br>
        <mat-label>Voting in progress </mat-label>
        <mat-label>{{value | number: '1.0-0'}} %</mat-label>
      </div> 
      <ng-template #showMessage>
        <b style="color: orangered;">Voting completed.</b>
      </ng-template>
      <div>
        <b>
          {{poll.message}}
        </b>
      </div>
      <div style="margin: 2rem;">
        <!-- <highcharts-chart [Highcharts]="highcharts1" [options]="chartOptions1"
                          style="width: 100%; height: 400px;">
        </highcharts-chart> -->
        <table>
          <tr>
            <th *ngFor="let data of displayedColumns1;">{{data}}</th>
          </tr>
          <tr *ngFor="let data of pollTabledata, let rowIndex = index">
            <td>Round : {{rowIndex + 1}}</td>
            <td *ngFor="let item of data | keyvalue">
              <!-- {{item.key}}:{{item.value}} : {{item.value}}/{{totalValue}}*100 -->
              <div style="margin-bottom: 5px;">{{item.value }}  </div>
              <div>{{ item.value/totalvoteCount | percent:'2.0-2' }}</div>
            </td>
          </tr>
        </table>
        <div style="margin: 5px;">
          <li>Total Members : {{totalPartcipent}}</li>
          <li>Voted: {{totalvoteCount}}</li>
          <li>Not Replied : {{notRepliedCount}}</li>
        </div>
      </div>
      <div style="height: 9vh;">
        <div  class="with-icon" style="display: inline-block;">
          <mat-icon style="color: rgb(125, 253, 125);" (click)="downloadCSV()"> download </mat-icon><span (click)="downloadCSV()">Download Results.</span>
          
          
        </div>
        <div *ngIf="poll.is_live && !pollexecute.poll_started && showProgressBar" style="float: right; background-color: rgb(171, 255, 171); margin: 1vh; border-radius: 1vh; ">
          <button  mat-button (click)="startVoteingForLivePoll()">Start Live Voting.</button>
        </div>
        <div *ngIf="showProgressBar" style="float: right; background-color: rgb(170, 166, 255); margin: 1vh; border-radius: 1vh; ">
          <button  mat-button (click)="sendReminder()">Nudge</button>
        </div>
        <div *ngIf="valueInstance <100  && showProgressBar" style="float: right; background-color: rgb(255, 192, 169); margin: 1vh; border-radius: 1vh; ">
          <button  mat-button (click)="cpmpletePollExecutionForspecificexecution()">Stop Voting.</button>
        </div>
      </div>
      
      <div [hidden]="true">
        <angular2csv [data]="data1" filename="{{poll.name +'-'+ pollexecute.created_at }}" [options]="options">
        </angular2csv>
      </div>
    </div>
      <table mat-table #table [dataSource]="dataSource" matSort>
      
          <ng-container matColumnDef="member_name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Member Name </th>
            <td mat-cell *matCellDef="let row"> {{row.member_name | titlecase}} </td>
          </ng-container>
  
          <ng-container matColumnDef="division">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Division </th>
            <td mat-cell *matCellDef="let row"> {{row.division | titlecase}} </td>
          </ng-container>
  
          <ng-container matColumnDef="response">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> View Voting Info</th>
            <td mat-cell *matCellDef="let row" (click)="openRankedChoiceResultComp(row,i)"> 
              <div [ngClass]="{'green-eye-icon': row.replied}">
                <mat-icon >remove_red_eye</mat-icon>
              </div>
            </td>
          </ng-container>
      
          <ng-container matColumnDef="parsed_response">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Matched Option </th>
            <td mat-cell *matCellDef="let row" > 
              <!-- <div *ngIf="poll.poll_type == 'ranked-choice'; else res">
                {{row.user_ranking}}
              </div>
              <ng-template #res>
                {{row.parsed_response  ? row.parsed_response : 'No Reply'}}
              </ng-template> -->
              {{row.parsed_response  ? row.parsed_response : 'No Reply'}}
             </td> 
          </ng-container>
  
          <ng-container matColumnDef="replied" >
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Replied  </th>
            <td mat-cell *matCellDef="let row"> 
              <div *ngIf="row.replied">
                <mat-icon>done</mat-icon>
              </div>
              <div *ngIf="!row.replied">
                <mat-icon>clear</mat-icon>
              </div>
            </td>
          </ng-container>
  
          <ng-container matColumnDef="id" >
            <th mat-header-cell *matHeaderCellDef> View </th>
            <td mat-cell *matCellDef="let row"> 
              <a href="{{smsInfoUrl + row.id}}" target="_blank">
                <mat-icon >remove_red_eye</mat-icon>
              </a>
            </td>
          </ng-container>
      
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  
          <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" colspan="4">No data found.</td>
          </tr>
      </table>
      
      <mat-paginator [pageSizeOptions]="[10, 20, 30]" showFirstLastButtons></mat-paginator>
  </div>
  
  